import { render, staticRenderFns } from "./Template9.vue?vue&type=template&id=62b9d1f2&scoped=true"
import script from "./Template9.vue?vue&type=script&lang=js"
export * from "./Template9.vue?vue&type=script&lang=js"
import style0 from "./Template9.vue?vue&type=style&index=0&id=62b9d1f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62b9d1f2",
  null
  
)

export default component.exports